export default __webpack_public_path__ + "static/media/rockDensity.207f20e4.png";